const googleSearchLogo = ({ width = 75, height = 75 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1354_2102)">
        <path
          d="M41.4949 0H22.5054L17.7744 4.76375V9.49475H22.5054V4.76375H41.4949V9.49475H46.2259V4.76375L41.4949 0Z"
          fill="#737373"
        />
        <path d="M22.5059 0V4.76375H41.4954V0H22.5059Z" fill="#BFBFBF" />
        <path
          d="M9.1005 9.495L0 18.5952V52.1395C0 54.7677 2.1355 56.8705 4.731 56.8705H59.269C61.8973 56.8705 64 54.7347 64 52.1395V18.6282L54.8665 9.495H9.1005Z"
          fill="url(#paint0_radial_1354_2102)"
        />
        <path
          d="M7.12891 27.269H56.9032V56.9035H7.12891V27.269Z"
          fill="white"
        />
        <path
          d="M9.1005 9.49475L0 18.5955V27.269H64V18.6283L54.8665 9.49475H9.1005Z"
          fill="#E0E0E0"
        />
        <path
          d="M10.6777 53.3225H32.0002V56.8708H10.6777V53.3225Z"
          fill="#D1D1D1"
        />
        <path
          d="M7.12891 21.7495C7.12812 21.266 7.22277 20.7871 7.40743 20.3403C7.59209 19.8935 7.86313 19.4875 8.20501 19.1456C8.54689 18.8038 8.95289 18.5328 9.39972 18.3481C9.84655 18.1635 10.3254 18.0689 10.8089 18.0697H53.1907C53.6741 18.0689 54.153 18.1636 54.5998 18.3482C55.0466 18.5328 55.4525 18.8039 55.7944 19.1457C56.1363 19.4876 56.4073 19.8935 56.5919 20.3403C56.7766 20.7871 56.8712 21.266 56.8704 21.7495V27.269H7.12891V21.7495Z"
          fill="#4285F4"
        />
        <path
          d="M14.226 22.5381C14.227 22.7713 14.1817 23.0024 14.0929 23.2181C14.0041 23.4337 13.8735 23.6297 13.7085 23.7946C13.5436 23.9595 13.3477 24.0902 13.132 24.179C12.9163 24.2678 12.6852 24.313 12.452 24.3121C12.2187 24.3131 11.9876 24.2678 11.7719 24.179C11.5562 24.0903 11.3602 23.9596 11.1953 23.7947C11.0303 23.6298 10.8997 23.4338 10.8109 23.2181C10.722 23.0024 10.6768 22.7713 10.6778 22.5381C10.6768 22.3048 10.722 22.0736 10.8108 21.8579C10.8996 21.6422 11.0303 21.4462 11.1952 21.2813C11.3602 21.1163 11.5561 20.9857 11.7719 20.8968C11.9876 20.808 12.2187 20.7628 12.452 20.7638C12.6853 20.7629 12.9164 20.8081 13.1321 20.8969C13.3478 20.9857 13.5437 21.1164 13.7086 21.2814C13.8736 21.4463 14.0042 21.6423 14.093 21.858C14.1818 22.0737 14.227 22.3048 14.226 22.5381ZM20.14 22.5381C20.141 22.7713 20.0957 23.0024 20.0069 23.2181C19.9181 23.4338 19.7874 23.6298 19.6225 23.7947C19.4575 23.9596 19.2615 24.0903 19.0458 24.179C18.8301 24.2678 18.599 24.3131 18.3658 24.3121C18.1325 24.313 17.9014 24.2678 17.6857 24.179C17.4701 24.0902 17.2741 23.9595 17.1092 23.7946C16.9443 23.6297 16.8136 23.4337 16.7248 23.2181C16.636 23.0024 16.5908 22.7713 16.5918 22.5381C16.5908 22.3048 16.636 22.0737 16.7248 21.858C16.8136 21.6423 16.9442 21.4463 17.1091 21.2814C17.274 21.1164 17.47 20.9857 17.6857 20.8969C17.9014 20.8081 18.1325 20.7629 18.3658 20.7638C18.599 20.7628 18.8302 20.808 19.0459 20.8968C19.2616 20.9857 19.4576 21.1163 19.6225 21.2813C19.7875 21.4462 19.9182 21.6422 20.007 21.8579C20.0958 22.0736 20.141 22.3048 20.14 22.5381Z"
          fill="#E6E6E6"
        />
        <path
          d="M56.871 41.2977L49.413 33.8397L46.916 41.5604L36.7313 31.4084L36.4355 47.0799L40.2138 52.9937C40.7723 52.8952 37.3883 56.8707 37.3883 56.8707H56.8708L56.871 41.2977Z"
          fill="#BABABA"
        />
        <path
          d="M52.2049 41.0019C52.2049 36.7967 49.7409 33.1827 46.2254 31.4414V41.4289L41.5274 43.9589L36.7634 41.4289V31.4084C33.2481 33.1499 30.8496 36.7967 30.8496 40.9692C30.8496 45.1744 33.2809 48.7884 36.7964 50.5297V56.8707H46.2584V50.5297C49.7409 48.8212 52.2049 45.1747 52.2049 41.0022"
          fill="#4D4D4D"
        />
        <path
          d="M10.6777 30.8173H27.2692V49.7743H10.6777V30.8173Z"
          fill="#D1D1D1"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1354_2102"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(221.84 1925.49) rotate(44.9918) scale(4462.41 3454.09)"
        >
          <stop stopColor="#F1F2F2" />
          <stop offset="1" stopColor="#E6E7E8" />
        </radialGradient>
        <clipPath id="clip0_1354_2102">
          <rect width="64" height="57" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default googleSearchLogo;
